import { BaseTag } from 'mixs/base/base_mixin';
import { Scopes }  from 'apps/scopes';
import moment  from 'moment';

class Phase extends BaseTag {
  orders_phases: any;
  memos: {}
  init(){
    super.init();
    this.orders_phases = {}
    this.memos = {}
  }
  phaseName(){
    let phaseData = Scopes.getPhaseData(this.opts.phaseId);
    return phaseData.name;
  }
  phaseColor(){
    let phaseData = Scopes.getPhaseData(this.opts.phaseId);
    return phaseData.colorcode;
  }
  orders(){
    let ary = []
    let tasks = this.opts.tasks[this.opts.phaseId]
    for(let i=0; i<tasks.length; i++){
      let task = tasks[i];
      let orderData = Scopes.getOrderData(task.order_id)
      ary.push( {o: orderData, t: task} );
    }
    return ary;
  }
  phaseIdentity(){
    let phaseData = Scopes.getPhaseData(this.opts.phaseId);
    return phaseData.identity;
  }
  setMemo(task){
    if(task.memos_index == null){                 this.memos[task.id] = null; return; }
    if(task.memos_index[this.opts.date] == null){ this.memos[task.id] = null; return; }
    this.memos[task.id] = task.memos_index[this.opts.date].value;
  }
  memo(task){
    if(this.memos[task.id] == undefined ){ this.setMemo(task); }
    if(this.memos[task.id] == null){ return null; }
    return this.memos[task.id];
  }
  casting_num(task){
    if(!task.taskable_id){ return '' }
    let taskableData = Scopes.getTaskableData(task.taskable_id, task.taskable_type)
    return taskableData.planned_num;
  }
  delivery_options(task){
    if(!task.taskable_id){ return '' }
    let taskableData = Scopes.getTaskableData(task.taskable_id, task.taskable_type)
    let delivery_option_ids = taskableData.delivery_option_ids;
    if(!delivery_option_ids){ return '' }
    let ary = []
    for(let i=0;i<delivery_option_ids.length;i++){
      let id = delivery_option_ids[i]
      let deliveryOptionData = Scopes.getDeliveryOptionData(id)
      let contents = deliveryOptionData.contents;
      ary.push(contents)
    }
    return ary.join(',');
  }
  delivery_who(task){
    if(!task.taskable_id){ return '' }
    let taskableData = Scopes.getTaskableData(task.taskable_id, task.taskable_type)
    return taskableData.who
  }
  setOrdersPhase(order){
    let orders_phase = null
    for(let i=0; i<order.phases.length; i++){
      if(order.phases[i].id == this.opts.phaseId){
        orders_phase = order.phases[i]
        break;
      }
    }
    this.orders_phases[order.id] = orders_phase
    return orders_phase
  }
  material(order){
    if(this.orders_phases[order.id] == undefined ){ this.setOrdersPhase(order) }
    if(this.orders_phases[order.id] == null){ return '' }
    if(this.orders_phases[order.id].material) { return this.orders_phases[order.id].material.value };
    return ''
  }
  heat_treatment(order){
    if(this.orders_phases[order.id] == undefined ){ this.setOrdersPhase(order) }
    if(this.orders_phases[order.id] == null){ return '' }
    if(this.orders_phases[order.id].heat_treatment) { return this.orders_phases[order.id].heat_treatment.value };
    return ''
  }
  requiredNumPhase(){
    let id = this.phaseIdentity();
    return id == 'delivery' || id == 'finishing' || id == 'process'
  }
  taskDescription(task){
    return task.memo
  }
}

riot.mixin('calendars.phase', Phase as riot.TagMixin)
